import React from 'react';
// import {graphql} from 'react-apollo';
// import {flowRight as compose} from 'lodash';

//utils
// import queries from '../../utils/queries'
import general from '../../modulos/general';

//Lista servicios tarifa
const ServiciosTar = ({styles, elemento, permAct, handleChangeTar, imptosCF}) => {
  // console.log(elemento)
  // console.log(elemento.valorServicios)
  // console.log(elemento.valorServicios.toString())
  // console.log(general.formatNum(elemento.valorServicios).toString())
    const rango1Ini = (valor) => {
      if(valor!==null){
        return valor
      }else{
        return ''
      }
    }
    return(
      <tr className=''>
        {permAct==='cambiar'?
          <td className='collapsing'>
            <div className='ui fitted slider checkbox'>
              <input type='checkbox' name='estadoSeleccPpal' id={elemento.codigoServicio} checked={elemento.estadoSelecc} onChange={(ev)=>handleChangeTar(ev, elemento, imptosCF)}/>
              <label />
            </div>
          </td>
        :
          <td className='center aligned'>{elemento.estadoServicio?elemento.estadoCliente?elemento.estadoCliente!=="ACTIVO"?"D":elemento.estadoServicio:"":""}</td>
        }
        <td className=''>{elemento.descrClaseServ}</td>
        <td className=''>{elemento.nombreResumido}</td>
        <td className=''>{elemento.descripcionServicio}</td>
        {/* <td className='center aligned' style={styles.styPaddMarg}>
          <input type='number' step="1" style={styles.styInput} autoComplete="off" name="numeroServicios" id={elemento.codigoServicio} value={rango1Ini(elemento.numeroServicios)} placeholder='# serv' onChange={permAct==='cambiar'?(ev)=>handleChangeTar(ev, elemento, imptosCF):()=>{}}/>
        </td>
        <td className='right aligned' style={styles.styPaddMarg}>
          <input type='number' step="1" style={styles.styInput} autoComplete="off" name="valorServicios" id={elemento.codigoServicio} value={general.formatNum(rango1Ini(elemento.valorServicios).toString())} placeholder='Valor serv' onChange={permAct==='cambiar'?(ev)=>handleChangeTar(ev, elemento, imptosCF):()=>{}}/>
        </td> */}

        <td className='center aligned' style={styles.styPaddMarg}>
          <input style={styles.styInput} autoComplete="off" name="numeroServicios" id={elemento.codigoServicio} value={rango1Ini(elemento.numeroServicios)} placeholder='# serv' onChange={permAct==='cambiar'?(ev)=>handleChangeTar(ev, elemento, imptosCF):()=>{}}/>
        </td>
        <td className='right aligned' style={styles.styPaddMarg}>
          <input style={styles.styInput} autoComplete="off" name="valorServicios" id={elemento._id} value={general.formatNum(rango1Ini(elemento.valorServicios).toString())} placeholder='Valor serv' onChange={permAct==='cambiar'?(ev)=>handleChangeTar(ev, elemento, imptosCF):()=>{}}/>
        </td>
      </tr>
    )
  };

//   const ListaServTar = ({list, permAct, handleChangeTar, imptosCF}) => {
class ListaServTar extends React.Component {
    render(){
    const nivel1Detalle = this.props.list.map((elemento, _id) => <ServiciosTar styles={this.props.styles} elemento={elemento} permAct={this.props.permAct} handleChangeTar={this.props.handleChangeTar} imptosCF={this.props.imptosCF} key={elemento._id}/>);
// console.log(this.props.list)
    return(
      <tbody className=''>
        {nivel1Detalle}
      </tbody>
    )
    }
  };

  export default ListaServTar
  // export default compose(
  //   graphql(queries.query.allTarifa, {name:'allTarifa', options: (props) => {return {variables: {}}}}),
  // )(ListaServTar)
  